import React, {Component, Fragment} from 'react';
import {
  Card,
  CardBody,
  Row,
  Col,
  Form,
  CardTitle,
  Label,
  Input,
} from 'reactstrap';
import {Field, Form as FinalForm} from 'react-final-form';
import {withTranslation} from 'react-i18next';
import TextField from '../../../../components/TextField';
import {Colxx, Separator} from '../../../../components/common/CustomBootstrap';
import {NotificationManager} from '../../../../components/common/react-notifications';
import LoaderButton from '../../../../components/LoaderButton';
import Api from '../../../../services/Api';
import Breadcrumb from '../../../../containers/navs/Breadcrumb';
import ReactQuill from 'react-quill';
import {modules, formats} from '../../../../constants/editorConfig';
import FieldError from '../../../../components/FieldError';
import {difference} from '../../../../helpers/Utils';
import {required} from '../../../../helpers/Validators';

class Update extends Component {
  constructor(props) {
    super(props);
    this.notification = props.location.state.notification;
    this.userId = props.location.state.userId;
  }

  updateNotification = async values => {
    const {t} = this.props;
    try {
      await Api.invoke(
        'PUT',
        this.userId ?
          '/admin-ui/user-notifications' :
          '/admin-ui/general-notifications',
        {
          ...difference(values, this.notification),
          id: this.notification.id,
        }
      );
      NotificationManager.success(t('Notification updated successfully'), t('Message'));
    } catch (e) {
      if (e.fieldError) {
        return e.fieldError;
      }
      throw e;
    }
  };

  render() {
    const {t, match} = this.props;
    return (
      <Fragment>
        {!this.userId && <Row>
          <Colxx xxs="12">
            <Breadcrumb match={match}/>
            <Separator className="mb-5"/>
          </Colxx>
        </Row>}
        <Row>
          <Colxx xxs="12" className="mb-4">
            <Card className="h-100">
              <CardBody>
                <CardTitle className="text-large text-primary">
                  {this.userId ? t('Update User Notification') : t('Update General Notification')}
                </CardTitle>
                <FinalForm
                  onSubmit={this.updateNotification}
                  initialValues={{
                    title: this.notification.title,
                    html: this.notification.html,
                    important: this.notification.important
                  }}
                  render={({handleSubmit, submitting, pristine, hasValidationErrors}) => {
                    return (
                      <Form onSubmit={handleSubmit}>
                        <Row>
                          <Col>
                            <TextField
                              item={{
                                name: 'title',
                                i18n: t('Title'),
                                type: 'text',
                                required: true,
                              }}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <span>
                             {t('Content')}
                              <span className="required">*</span>
                            </span>
                            <Field name='html' validate={required}>
                              {({input}) => (
                                <ReactQuill
                                  {...input}
                                  theme='snow'
                                  modules={modules}
                                  formats={formats}
                                  preserveWhitespace={true}
                                  onChange={(value, delta) => {
                                    if (delta.ops.length === 1 && delta.ops[0].delete) {
                                      input.onChange(undefined);
                                    } else {
                                      input.onChange(value);
                                    }
                                  }}
                                />
                              )}
                            </Field>
                            <FieldError name='html' />
                          </Col>
                        </Row>
                        <Row className='mt-2'>
                          <Col>
                            <Field name='important'>
                              {({input}) => (
                                <Label check className='d-flex flex-row align-items-center'>
                                  <Input
                                    type="checkbox"
                                    className='m-0'
                                    checked={input.value}
                                    onChange={e => {input.onChange(Number(e.target.checked));}}
                                  />
                                  <span className='ml-3'>{t('Display as soon as the user logs in')}</span>
                                </Label>
                              )}
                            </Field>
                          </Col>
                        </Row>
                        <LoaderButton
                          loading={submitting}
                          onClick={handleSubmit}
                          disabled={pristine || hasValidationErrors || submitting}
                          className="mt-4 text-center"
                          style={{minWidth: '100px'}}>
                          {t('Save')}
                        </LoaderButton>
                      </Form>
                    );
                  }}
                />
              </CardBody>
            </Card>
          </Colxx>
        </Row>
      </Fragment>
    );
  }
}

export default withTranslation()(Update);
